import { DynamicStandaloneJwVideoTeaser } from '@/components/JwVideo/Teaser';
import { componentTheme } from '@/styles/JwVideoTeaser';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

export const AllasLabradorVideoTeaser: LabradorComponent = ({ type, meta, data }) => {
  const { videoID, thumbnail, isFrontPage, teaserLink, title, hintText, stillImage, prominentTag } = data;

  const componentProps = {
    mediaId: videoID,
    teaserLink,
    thumbnail,
    title,
    hintText,
    isStillImage: stillImage,
    tag: prominentTag,
    ...(isFrontPage
      ? {
          options: {
            theme: componentTheme('front_page'),
            variant: 'vertical',
            $content: {
              $tag: {
                theme: componentTheme('tag'),
              },
            },
          },
        }
      : {
          options: {
            colors: 'primary',
            variant: 'horizontal',
            $content: {
              $tag: {
                theme: componentTheme('tag'),
              },
            },
            $icon: {
              colors: 'default',
            },
          },
        }),
  };

  return <DynamicStandaloneJwVideoTeaser {...componentProps} {...withDebugMetadata({ type, meta })} />;
};

export default AllasLabradorVideoTeaser;
